import React, { useState, useMemo, useEffect } from 'react';
import { useSortBy, useTable, usePagination } from 'react-table';
import axios from 'axios';
import {
	AUTHORIZED_URL_PREFIX,
	NOTIFICATION_SEVERITY_INFO,
    NOTIFICATION_SEVERITY_SUCCESS,
    ASSIGN_NEW_EDITION_CODE_URL,
    AxiosConfig
} from '../../Utils/Constants';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from "react-bootstrap/Form";
import LykioButton from "../common/LykioButton";
import t from '../../Utils/Translation';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import friendlyDate from '../../Utils/FriendlyDate';

const UserEditionCodesModal = (props) => {
    const show = props.show;
    const handleClose = props.handleClose;
    const [selectedEditionCode, setSelectedEditionCode] = useState('');
    const editionCodeNameMap = {};
   
    console.log("props.editionCodesList",props.editionCodesList);

    props.editionCodesList.forEach((editionCode) => {
        editionCodeNameMap[editionCode._id] = editionCode.name;
    });
    
    const convertIdToString = (stringId) => {
        return stringId.toString(); // Convert to string if it's not already
    };

    const availableEditionCodes = props.editionCodesList
    .filter((editionCode) => editionCode.status === true)
    .filter((editionCode) => {
      const editionCodeId = convertIdToString(editionCode._id);
      return !props.userEditionCodes.some(
        (assignedCode) => convertIdToString(assignedCode.editionCode) === editionCodeId
      );
    });

    const assignedEditionCodes = props.userEditionCodes.map((assignedCode) => {
        const editionCodeId = convertIdToString(assignedCode.editionCode);
        const editionCodeName = editionCodeNameMap[editionCodeId];
        const matchingCode = props.editionCodesList.find(
          (code) => code.name === editionCodeName
        );
        return {
          editionCodeId: assignedCode._id,
          editionCodeName: editionCodeName,
          duration: assignedCode.duration,
          status: assignedCode.status,
          codeStatus: matchingCode ? matchingCode.status : assignedCode.status,
          assignDate: assignedCode.assignDate,
        };
      });

    const [ myTableData, setmyTableData ] = useState(useMemo(() => [ ...assignedEditionCodes ], []));

    const myTableColumns = useMemo(
		() => [
			{
				Header: t('Code Name'),
				accessor: 'editionCodeName'
			},
      {
				Header: t('Code Status'),
				accessor: 'codeStatus',
        Cell: ({ value }) => (value ? "Active" : "Inactive")
			},
			{
				Header: t('Assigned at'),
				accessor: 'assignDate',
        Cell: ({ value }) => {
					return friendlyDate(new Date(value));
				}
			},
      // {
      //   Header: t('Action'),
      //   Cell: ({ row }) => (
      //     <button
      //       onClick={() => {
      //         // You can customize this alert message with whatever info is available
      //         alert(
      //           `Edition Code ID: ${JSON.stringify(row.original)}\nUser ID: ${props.userId}`
      //         );
      //       }}
      //     >
      //       {t('Show Info')}
      //     </button>
      //   )
      // }
		],
		[]
	);
    
    //React Table Setup
	const tableInstance = useTable(
		{ columns: myTableColumns, data: myTableData },
		useSortBy,
        usePagination
	);
    
    const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		nextPage,
		previousPage,
		canNextPage,
		canPreviousPage,
		pageOptions,
		gotoPage,
		pageCount,
		setPageSize,
		state,
		prepareRow
	} = tableInstance;

    const { pageIndex, pageSize } = state;
    
    // handler to assign a new edition code for the user
    const assignEditionCode = async () => {
        if (selectedEditionCode) {
          try {
            const selectedCode = props.editionCodesList.find(
              (code) => code.name === selectedEditionCode
            );
      
            if (selectedCode) {
              const { data } = await axios.post(
                `${AUTHORIZED_URL_PREFIX}${ASSIGN_NEW_EDITION_CODE_URL}`,
                {
                  userId: props.userId,
                  editionCodeId: selectedCode._id, 
                  assignDate: new Date(),
                },
                AxiosConfig()
              );
      
              if (data.success === true) {
                notify({
                  title: `${t('New Edition Code Assigned')}`,
                  severity: NOTIFICATION_SEVERITY_SUCCESS,
                  creationDate: '',
                });
                window.dispatchEvent(new Event('userEditionCodeAdded'));
                // Optionally, you can update the state to reflect the change immediately
                setSelectedEditionCode('');
              } 
            } else {
              notify({
                title: `${t('Edition Code not found.')}`,
                severity: NOTIFICATION_SEVERITY_INFO,
                creationDate: '',
              });
            }
          } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
              notify({
                title: `${t(`This edition code is already assigned to the user.`)}`,
                severity: NOTIFICATION_SEVERITY_INFO,
                creationDate: '',
              });
            } else {
            console.log(error);
            notify(pleaseRefreshError);
            }
          }
          
        } else {
          notify({
            title: `${t('Please select an edition code.')}`,
            severity: NOTIFICATION_SEVERITY_INFO,
            creationDate: '',
          });
        }
      };
      
      

    return (
        <React.Fragment>
            <Modal size="lg" centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <div className="lykiocss-material-table">
                                <Table striped bordered hover size="sm" {...getTableProps()}>
                                    <TableHead>
                                        {headerGroups.map((headerGroup) => (
                                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map((column) => (
                                                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                                        {column.render('Header')}
                                                        {column.isSorted ? column.isSortedDesc ? ' ↓' : ' ↑' : ''}
                                                    </th>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableHead>
                                    <TableBody {...getTableBodyProps()}>
                                        {page.map((row) => {
                                            prepareRow(row);
                                            return (
                                                <TableRow {...row.getRowProps()}>
                                                    {row.cells.map((cell) => {
                                                        return <TableCell {...cell.getCellProps()}>{cell.render('Cell')}</TableCell>;
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </div>
                        </Row>
                        <Row style={{marginTop:'1rem'}}>
                            <Col md={8} style={{marginBottom:'1rem'}}>
                                <Form.Select value={selectedEditionCode} onChange={(e) => setSelectedEditionCode(e.target.value)}>
                                <option value="">{t('Select an edition code')}</option>
                                {availableEditionCodes.map((code) => (
                                    <option key={code._id} value={code.name}>
                                    {code.name}
                                    </option>
                                ))}
                                </Form.Select>
                            </Col>
                            <Col md={4}>
                            <LykioButton                        
                                variant="contained"
                                onClick={assignEditionCode}
                            >
                                {t("Assign New Code")}
                            </LykioButton>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}
export default UserEditionCodesModal;